import React from 'react'
import { StyledRadio } from './styled'

const Radio = ({ id, name, value, onChange }) => {
	return <StyledRadio id={id} name={name} value={value} onChange={onChange} />
}

export default Radio
